import { Paragraph } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledNoWrapParagraph = styled(Paragraph)`
  white-space: nowrap;
`;

export const StyledFullHeightDiv = styled.div`
  height: 100%;
`;
